'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _UIButtonGroup = require('UIComponents/button/UIButtonGroup');

var _UIButtonGroup2 = _interopRequireDefault(_UIButtonGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FullWidthButtonGroup = (0, _styledComponents2.default)(_UIButtonGroup2.default).withConfig({
  displayName: 'CalculatorButtonGroup__FullWidthButtonGroup'
})(['width:100%;']);

var CalculatorButtonGroup = function CalculatorButtonGroup(_ref) {
  var children = _ref.children;

  return _react2.default.createElement(
    FullWidthButtonGroup,
    { className: 'm-top-3' },
    children
  );
};

exports.default = CalculatorButtonGroup;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/common/CalculatorButtonGroup.js
// module id = 738
// module chunks = 3 4